// extracted by mini-css-extract-plugin
export default {"host":"styles_host__LkAVh","label":"styles_label__jVnC5","checked":"styles_checked__XoDp4","disabled":"styles_disabled__y-ghw","input":"styles_input__wKDTE"};